import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { BuildByTaskDialogData } from '@app/shared/components/dialogs/build-by-task-dialog/build-by-task-dialog.data';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Store } from '@src/store';
import { cmsActions } from '@src/store/reducers/cmsReducer';

@Component({
    selector: 'build-by-task-dialog',
    template: require('./build-by-task-dialog.component.html'),
    styles: [require('./build-by-task-dialog.component.scss')]
})
export class BuildByTaskDialogComponent implements OnInit {

    public querySelected: any;

    public myControl = new FormControl();
    public filteredOptions: Observable<any[]>;
    @ViewChild('taskSearch') public taskSearch;

    constructor(private store: Store, @Inject(MAT_DIALOG_DATA) public data: BuildByTaskDialogData) {
    }

    public ngOnInit(): void {
        this.filteredOptions = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(val => this.tasksFilter(val))
            );
    }

    public onRemove(item: any) {
        this.data.selectedTasksForBuild = this.data.selectedTasksForBuild.filter(task => item.id !== task.id);
        this.data.tasks.push(item);
    }

    public onChangeTask(item) {
        const selectedTask = item;
        this.data.tasks = this.data.tasks.filter(task => selectedTask.id !== task.id);
        this.data.selectedTasksForBuild.push(selectedTask);
        this.myControl.setValue('');
        this.taskSearch.nativeElement.blur();
    }

    private tasksFilter(value: string): any {
        if (!value) {
            return this.data.tasks;
        }
        const filterValue = value.toLowerCase();
        return this.data.tasks.filter(task => `${task.id} - ${task.name.toLowerCase()}`.includes(filterValue));
    }

    public onQueryChange() {
        this.data.tasks = [];
        if (this.querySelected) {
            this.store.dispatch({
                type: cmsActions.GET_TASKS_BY_QUERY_ID,
                payload: { projectId: this.data.projectId, queryId: this.querySelected.id }
            }).then((res) => {
                this.taskProcessing(res);
            });
        } else {
            this.store.dispatch({
                type: cmsActions.GET_CHECKIN_TASKS_BY_PROJECT_ID, payload:
                    { projectId: this.data.projectId }
            }).then((res) => {
                this.taskProcessing(res);
            });
        }
    }

    private taskProcessing(tasks: any[]) {
        tasks.forEach(item => item.id = item.taskId);
        this.data.tasks = tasks.filter((task) => {
            return !this.data.selectedTasksForBuild.find(selectedTask => task.id === selectedTask.id);
        });
        this.myControl.setValue('');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/build-by-task-dialog/build-by-task-dialog.component.ts